import React, { useEffect } from 'react';
import SectionTitle from '../../components/SectionTitle/SectionTitle';
import '../../../stylesheets/stylesLayout/dashboard.scss';
import TypeaheadSearchbar from './TypeaheadSearchbar';
import useTranslate from '../../../customHooks/useTranslate';
import {
    useDashboard,
    useHotelsBooked,
    useHistoryBookings,
} from '../../../contexts/DashboardContext';
import Card from '../../../muiComponents/Card';
import MostBookedChart from './dashboardCharts/MostBookedChart';
import BookingHistoryChart from './dashboardCharts/BookingHistoryChart';
import UpcomingCheckInsList from './dashboardCharts/UpcomingCheckInsList';
import KPIs from './dashboardCharts/KPIs';

export default function OwnerPortalLanding() {
    const translate = useTranslate();

    const { getChartsInitialData } = useDashboard();
    const { isDataLoaded: isDataLoadedHotelsBooked } = useHotelsBooked();
    const { isDataLoaded: isDataLoadedBookingHistory } = useHistoryBookings();

    useEffect(() => {
        if (!isDataLoadedHotelsBooked || !isDataLoadedBookingHistory) {
            getChartsInitialData();
        }
    }, []);

    return (
        <div className='dashboard__container'>
            <header className='flex flex-between gap-20 flex-align-center padding-inline-10'>
                <SectionTitle title={translate('welcome_landing')} />
                <TypeaheadSearchbar />
            </header>
            <main className='flex-grow dashboard__content'>
                <Card className='padding20 flex-column gap-20 height100perc dashboard__booking-history'>
                    <BookingHistoryChart />
                </Card>

                <Card className='padding20 flex-column gap-20 height100perc dashboard__next-bookings'>
                    <UpcomingCheckInsList />
                </Card>

                <KPIs />

                <Card className='padding20 flex-column gap-20 height100perc dashboard__most-booked-hotels'>
                    <MostBookedChart />
                </Card>
            </main>
        </div>
    );
}
